import React from 'react';
import SvgIcn from "../data/IconCompo";
import '../ut_styles/backButton.scss';

const BackButton = () => {
  return (
    <div
      className="back-button"
      onClick={() => window.location.href = '/uudtools'}
      title="Go back to UUDTools"
    >
      <SvgIcn name="home" hover="icon01" />
    </div>
  );
};

export default BackButton; 